/**
 * Created by Jerker Nord on 2021-09-22.
 */
import {TrueGritScatterSymbol} from "../reels/TrueGritScatterSymbol";
import {ISymbolPosition, SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {TrueGrit} from "../TrueGrit";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {TrueGritGameData} from "../server/TrueGritData";

export class TrueGritScatterSymbols {

    private _scatterSymbols:TrueGritScatterSymbol[];
    private _shootingComplete:number = 0;

    constructor() {
    }

    public init():void {
        this._scatterSymbols = [];
        let tempScatter:TrueGritScatterSymbol;
        for(let i:number = 0; i < 6; i++) {
            tempScatter = new TrueGritScatterSymbol("S");
            this._scatterSymbols.push(tempScatter);
        }
    }

    public addListener():void{
        for(let i:number = 1; i < 4; i++) {
            TrueGrit.allReelsView.mainReelModels[i].events?.on(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data));
        }
    }

    private onReelStop(data:SimpleReelModelEventData) {
        if (data.reel == TrueGrit.model.highestNearWinScatterReel) {
            for(let i:number = 0; i < this._scatterSymbols.length; i++) {
                if (this._scatterSymbols[i].isUsed == true && this._scatterSymbols[i].waitForAnticipation == true){
                    this._scatterSymbols[i].waitForAnticipation = false;
                    this._scatterSymbols[i].playScatterWaitingDoneAnimation();
                }
            }
        }
    }

    public getScatterSymbol(symbolPositionData:ISymbolPosition):TrueGritScatterSymbol {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == false) {
                this._scatterSymbols[i].shootingAnimationComplete = false;
                this._scatterSymbols[i].isUsed = true;
                if (symbolPositionData.reelId <= TrueGrit.model.highestNearWinScatterReel){
                    this._scatterSymbols[i].waitForAnticipation = true;
                }else{
                    this._scatterSymbols[i].waitForAnticipation = false;
                }
                this._scatterSymbols[i].reelId = symbolPositionData.reelId;
                this._scatterSymbols[i].reelPosition = symbolPositionData.startPosition;
                (<TrueGritScatterSymbol>this._scatterSymbols[i]).forceSetSplitLevel(0);
                this._scatterSymbols[i].symbolName = "S";
                (<TrueGritScatterSymbol>this._scatterSymbols[i]).setCurrentStateSpriteTexture();
                return this._scatterSymbols[i];
            }
        }
        throw new Error("TrueGritScatterSymbols: No Scatters left in the pool!");
    }

    public getScattersLanded():number {
        let landed:number = 0;
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].landedInThisRound == true) {
                landed++;
            }
        }
        return landed;
    }

    // #295
    public getAllUsedScatters(): TrueGritScatterSymbol[] {
        return this._scatterSymbols.filter((sym: TrueGritScatterSymbol) => sym.isUsed);
    }

    public getShootingAnimationsStarted():number {
        let started:number = 0;
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].shootingAnimationStarted == true) {
                started++;
            }
        }
        return started;
    }

    /*
    public checkToPlayEndAnimation():void {
        this._shootingComplete++;
        let spinBackSoundPlayed:boolean = false;
        if(this._shootingComplete == this.getShootingAnimationsStarted()) {
            this._shootingComplete = 0;
            for(let i:number = 0; i < this._scatterSymbols.length; i++) {
                if(this._scatterSymbols[i].shootingAnimationComplete == true) {
                    if (spinBackSoundPlayed == false){
                        spinBackSoundPlayed = true;
                        TrueGrit.soundPlayer.playSound(TrueGritSound.SCATTER_SPIN_BACK_SOUND);
                    }
                    this._scatterSymbols[i].shootingAnimationComplete = false;
                    this._scatterSymbols[i].shootingAnimationStarted = false;
                    this._scatterSymbols[i].playSpinToEndAnimation();
                }
            }
        }
    }

     */
}